(function () {
  var ATTRIBUTE = 'data-usd-price-convert';
  var TIER_ATTRIBUTE = 'data-usd-price-convert-tier';
  var SELECTOR = '[' + ATTRIBUTE + '], [' + TIER_ATTRIBUTE + ']';
  var pricePattern = /\$[\d,]+(?:\.\d{2})?/g;

  var CURRENCY_LOCALES = {
    EUR: 'de-DE',
    EUR: 'fr-EU',
    GBP: 'en-GB',
    USD: 'en-US',
    CAD: 'en-CA',
    AUD: 'en-AU',
    NZD: 'en-NZ',
    CHF: 'de-CH',
    SEK: 'sv-SE',
    NOK: 'nb-NO',
    DKK: 'da-DK',
    PLN: 'pl-PL'
  };

  function parseUsdPrice(match) {
    return parseFloat(match.replace(/[$,]/g, ''));
  }

  function roundUpTo95(amount) {
    if (amount < 1) {
      return Math.round(amount * 100) / 100;
    }

    return Math.ceil(amount) + 0.95;
  }

  function convertUsdThreshold(usdAmount, rate) {
    var usd = parseFloat(usdAmount);

    if (isNaN(usd)) {
      return 0;
    }

    return Math.round(usd * rate * 100) / 100;
  }

  function getLocaleForCurrency(currency) {
    if (CURRENCY_LOCALES[currency]) {
      return CURRENCY_LOCALES[currency];
    }

    if (typeof document !== 'undefined' && document.documentElement.lang) {
      return document.documentElement.lang;
    }

    return undefined;
  }

  function shouldUseThemeFormatter(currency) {
    if (typeof window.themeFormatMoneyMajorUnits !== 'function') {
      return false;
    }

    if (!window.themeVariables || !window.themeVariables.settings) {
      return false;
    }

    var format = window.themeVariables.settings.moneyFormat || '';

    if (currency === 'EUR') {
      return format.indexOf('amount_with_comma_separator') !== -1;
    }

    return true;
  }

  function createPriceFormatter(currency) {
    if (shouldUseThemeFormatter(currency)) {
      return function (amount) {
        return window.themeFormatMoneyMajorUnits(amount);
      };
    }

    var formatter = new Intl.NumberFormat(getLocaleForCurrency(currency), {
      style: 'currency',
      currency: currency
    });

    return function (amount) {
      return formatter.format(amount);
    };
  }

  function formatTierOnePrice(currency) {
    if (typeof window.formatMoney === 'function' && window.themeVariables && window.themeVariables.settings) {
      var fmt = window.themeVariables.settings.currencyCodeEnabled
        ? window.themeVariables.settings.moneyWithCurrencyFormat
        : window.themeVariables.settings.moneyFormat;
      var noDecimalsFmt = fmt
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, '{{ amount_no_decimals_with_comma_separator }}')
        .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, '{{ amount_no_decimals_with_space_separator }}')
        .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, '{{ amount_no_decimals_with_apostrophe_separator }}')
        .replace(/\{\{\s*amount\s*\}\}/g, '{{ amount_no_decimals }}');

      return window.formatMoney(100, noDecimalsFmt);
    }

    return new Intl.NumberFormat(getLocaleForCurrency(currency), {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(1);
  }

  function convertTextNode(textNode, formatPrice, rate, isTierValue, currency) {
    var text = textNode.nodeValue;
    if (!text || text.indexOf('$') === -1) return;

    var updated = text.replace(pricePattern, function (match) {
      var usd = parseUsdPrice(match);
      if (isNaN(usd)) return match;
      if (isTierValue && usd === 1) return formatTierOnePrice(currency);
      return formatPrice(roundUpTo95(usd * rate));
    });

    if (updated !== text) {
      textNode.nodeValue = updated;
    }
  }

  function convertElementPrices(element, formatPrice, rate, currency) {
    var isTierValue = element.hasAttribute(TIER_ATTRIBUTE);
    var walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    var textNode;

    while ((textNode = walker.nextNode())) {
      pricePattern.lastIndex = 0;
      convertTextNode(textNode, formatPrice, rate, isTierValue, currency);
    }
  }

  function parseMessageTemplate(element) {
    var template = element.getAttribute('data-message-template');

    if (!template) {
      return '';
    }

    try {
      return JSON.parse(template);
    } catch (error) {
      return template;
    }
  }

  function updatePromotionMessage(element, template, formattedAmount) {
    var html = template.replace(/\{amount\}/g, formattedAmount);
    var icon = element.querySelector('.promotion-container-header-message-link-icon');

    if (icon) {
      var iconClone = icon.cloneNode(true);
      element.innerHTML = html;
      element.appendChild(iconClone);
      return;
    }

    element.innerHTML = html;
  }

  function convertCartPromotionThresholds(formatPrice, rate) {
    document.querySelectorAll('[data-cart-promotion-value]').forEach(function (container) {
      var cartTotal = parseFloat(container.getAttribute('data-cart-total')) || 0;
      var totalThresholdUsd = parseFloat(container.getAttribute('data-total-threshold-usd')) || 0;
      var totalThreshold = convertUsdThreshold(totalThresholdUsd, rate);
      var progressElement = container.querySelector('.promotion-container-tiers-progress-value');

      if (progressElement) {
        var progress = totalThreshold > 0
          ? Math.min(100, Math.round((cartTotal / totalThreshold) * 100))
          : 100;

        progressElement.style.width = (cartTotal < totalThreshold ? progress : 100) + '%';
      }

      container.querySelectorAll('.value-tier-container[data-tier-threshold-usd]').forEach(function (tierElement) {
        var thresholdUsd = parseFloat(tierElement.getAttribute('data-tier-threshold-usd')) || 0;
        var convertedThreshold = convertUsdThreshold(thresholdUsd, rate);

        tierElement.classList.toggle('active', cartTotal > convertedThreshold);
      });

      container.querySelectorAll('[data-promotion-message]').forEach(function (messageElement) {
        var messageIndex = parseInt(messageElement.getAttribute('data-message-index'), 10) || 0;
        var thresholdPrevUsd = parseFloat(messageElement.getAttribute('data-threshold-prev-usd')) || 0;
        var thresholdNextUsd = parseFloat(messageElement.getAttribute('data-threshold-next-usd')) || 0;
        var thresholdPrev = convertUsdThreshold(thresholdPrevUsd, rate);
        var remaining = Math.max(0, convertUsdThreshold(thresholdNextUsd, rate) - cartTotal);
        var template = parseMessageTemplate(messageElement);

        if (template) {
          updatePromotionMessage(messageElement, template, formatPrice(remaining));
        }

        if (messageIndex === 0) {
          messageElement.classList.add('active');
          return;
        }

        var isLink = messageElement.tagName === 'A';
        var isActive = isLink ? cartTotal > thresholdPrev : cartTotal >= thresholdPrev;

        messageElement.classList.toggle('active', isActive);
      });

      var lastActiveIndex = 0;

      container.querySelectorAll('[data-promotion-congrats]').forEach(function (congratsElement) {
        var thresholdUsd = parseFloat(congratsElement.getAttribute('data-tier-threshold-usd')) || 0;
        var congratsIndex = parseInt(congratsElement.getAttribute('data-congrats-index'), 10) || 0;

        if (thresholdUsd > 0 && cartTotal >= convertUsdThreshold(thresholdUsd, rate)) {
          lastActiveIndex = congratsIndex;
        }
      });

      container.querySelectorAll('[data-promotion-congrats]').forEach(function (congratsElement) {
        var congratsIndex = parseInt(congratsElement.getAttribute('data-congrats-index'), 10) || 0;

        congratsElement.classList.toggle('active', congratsIndex === lastActiveIndex);
      });
    });
  }

  function convertUsdPrices() {
    if (typeof Shopify === 'undefined' || !Shopify.currency) return;

    var activeCurrency = Shopify.currency.active;
    var rate = parseFloat(Shopify.currency.rate);

    if (activeCurrency === 'USD' || rate === 1) return;

    var formatPrice = createPriceFormatter(activeCurrency);

    document.querySelectorAll(SELECTOR).forEach(function (element) {
      convertElementPrices(element, formatPrice, rate, activeCurrency);
    });

    convertCartPromotionThresholds(formatPrice, rate);
  }

  window.convertUsdPrices = convertUsdPrices;

  document.addEventListener('DOMContentLoaded', convertUsdPrices);
  document.addEventListener('cart:refresh', convertUsdPrices);
  document.addEventListener('cart:change', convertUsdPrices);
  document.addEventListener('shopify:section:load', convertUsdPrices);
})();
